/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { useState } from "react"
import { useLocation } from "react-router-dom"
import { SchedulesListStateType } from "../../../../models/list"
import { useExportFile } from "../useExportFile"
import { useRouters } from "../useRouters"
import { useApi } from "../useApi"
import { useTableConfig } from "../useTableConfig"
import { useVariablesUtils } from "../useVariablesUtils"
import { useVariablesAuthority } from "../useVariablesAuthority"
import { getBreadcrumbItems } from "./getBreadcrumbItems"
import { useFormAdvanced } from "../useFormAdvanced"
import { useDatePicker } from "../../../../../../../utils/hook/useDatePicker"
import { Routers } from "../../../../../../../constant/Routers"

const { SCR210 } = Routers

export const useVariables = () => {
  const { state, pathname } = useLocation<SchedulesListStateType>()
  const breadcrumbItems = getBreadcrumbItems(
    pathname,
    state?.isFromSCR114UserSearch,
  )
  const [departureCountryCode, setDepartureCountryCode] = useState("")

  const {
    allCountries,
    departureCities,
    personPrefectureResidence,
    transportation,
  } = useVariablesUtils({
    departureCountryCode,
  })
  // 画面のメインボタンの初期表示処理を行う。
  const {
    isAuthorities,
    isHiddenBtnCreateOrSendAttentions,
    isHiddenBtnCreateOrSendSafeties,
    isHiddenBtnDelete,
    isHiddenBtnEdit,
    isHiddenBtnExportCsv,
    isHiddenBtnExportExcel,
    isHiddenBtnExportExcelSafeties,
    isHiddenBtnExportExcelTravelers,
    isHiddenBtnRefer,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isPathnameSchedules,
    isPathnameSchedulesOrTravelers,
    isPathnameTravelers,
    isRoleSubAdmin,
  } = useVariablesAuthority(state?.isFromSCR114UserSearch)

  const isGetCountries = pathname !== SCR210 && isRoleSubAdmin

  const {
    arrivalCities,
    countries,
    dataSource,
    dataSourceSelected,
    departments,
    dispatchType,
    dispatchTypeAll,
    dispatchTypeDetail,
    form,
    formAdvanced,
    fullName,
    getArrivalCities,
    getData,
    getSchedules,
    handleAdvancedSearch,
    handleSearch,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isLoadingLayout,
    isLoadingTable,
    isOpen,
    isOpenLoadData,
    isOpenShowData,
    isOverseasResident,
    isPathnameAttentionsOrSafeties,
    isResetTable,
    isSearchAdvance,
    isSearchBasic,
    onCancel,
    onCancelCustomLoadData,
    onChange,
    onChangeDispatchType,
    onChangeTable,
    onOkLoadData,
    onOkShowData,
    onOpen,
    overRecordLabel,
    perItem,
    purposeTravel,
    rowSelection,
    searchCondition,
    selectedRowKeys,
    setArrivalCities,
    setIsOverseasResident,
    setIsSearchAdvance,
    setSearchCondition,
    setSearchConditionAdvanced,
    setTravelerId,
    sortedInfo,
    travelScheduleId,
    userInformation,
  } = useApi({ allCountries, isGetCountries, isRoleSubAdmin })

  const {
    handleCancelModalExport,
    handleExportFile,
    handleOpenModalExport,
    isOpenModalExport,
    messageConfirmDownload,
    push,
  } = useExportFile({ dataSource, selectedRowKeys })

  const {
    goBack,
    goToAttention,
    goToSafety,
    goToSchedulesAdd,
    goToSchedulesConfirmDelete,
    goToSchedulesDetail,
    goToSchedulesEdit,
  } = useRouters({
    dataSourceSelected,
    isFromSCR114UserSearch: state?.isFromSCR114UserSearch,
    isSearchBasic,
    searchCondition,
    searchConditionTraveler: state?.searchConditionTraveler,
    travelScheduleId,
    travelerId: state?.travelerId,
  })
  const { onBlur: onBlurBasic, onKeyDown: onKeyDownBasic } = useDatePicker({
    form,
  })

  const [isDisabledArrivalCity, setIsDisabledArrivalCity] = useState(true)
  const [isDisabledDepartureCity, setIsDisabledDepartureCity] = useState(true)

  const { columns } = useTableConfig(isPathnameSchedules, sortedInfo)
  const {
    arrivalHourItems,
    arrivalMinuteItems,
    isDefaultValueArrivalDate,
    isDefaultValueDepartureDate,
    onChangeArrivalDate,
    onChangeDepartureDate,
    onValuesChangeFormSearchAdvanced,
  } = useFormAdvanced(formAdvanced)

  return {
    allCountries,
    arrivalCities,
    arrivalHourItems,
    arrivalMinuteItems,
    breadcrumbItems,
    columns,
    countries,
    dataSource,
    departments,
    departureCities,
    dispatchType,
    dispatchTypeAll,
    dispatchTypeDetail,
    form,
    formAdvanced,
    fullName,
    getArrivalCities,
    getData,
    getSchedules,
    goBack,
    goToAttention,
    goToSafety,
    goToSchedulesAdd,
    goToSchedulesConfirmDelete,
    goToSchedulesDetail,
    goToSchedulesEdit,
    handleAdvancedSearch,
    handleCancelModalExport,
    handleExportFile,
    handleOpenModalExport,
    handleSearch,
    isAuthorities,
    isDefaultValueArrivalDate,
    isDefaultValueDepartureDate,
    isDisabledArrivalCity,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDepartureCity,
    isDisabledDispatchTypeDetail,
    isFromSCR114UserSearch: state?.isFromSCR114UserSearch,
    isGetCountries,
    isHiddenBtnCreateOrSendAttentions,
    isHiddenBtnCreateOrSendSafeties,
    isHiddenBtnDelete,
    isHiddenBtnEdit,
    isHiddenBtnExportCsv,
    isHiddenBtnExportExcel,
    isHiddenBtnExportExcelSafeties,
    isHiddenBtnExportExcelTravelers,
    isHiddenBtnRefer,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isLoadingLayout,
    isLoadingTable,
    isOpen,
    isOpenLoadData,
    isOpenModalExport,
    isOpenShowData,
    isOverseasResident,
    isPathnameAttentionsOrSafeties,
    isPathnameSchedules,
    isPathnameSchedulesOrTravelers,
    isPathnameTravelers,
    isResetTable,
    isSearchAdvance,
    isSearchBasic,
    messageConfirmDownload,
    onBlurBasic,
    onCancel,
    onCancelCustomLoadData,
    onChange,
    onChangeArrivalDate,
    onChangeDepartureDate,
    onChangeDispatchType,
    onChangeTable,
    onKeyDownBasic,
    onOkLoadData,
    onOkShowData,
    onOpen,
    onValuesChangeFormSearchAdvanced,
    overRecordLabel,
    pathname,
    perItem,
    personPrefectureResidence,
    purposeTravel,
    push,
    rowSelection,
    searchCondition,
    setArrivalCities,
    setDepartureCountryCode,
    setIsDisabledArrivalCity,
    setIsDisabledDepartureCity,
    setIsOverseasResident,
    setIsSearchAdvance,
    setSearchCondition,
    setSearchConditionAdvanced,
    setTravelerId,
    state,
    transportation,
    userInformation,
  }
}
